exports = module.exports = require("./../../../node_modules/custom-react-scripts/node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".XFcTiFjPua2V0mykElKpy{padding-left:16px!important}._3zf_WOadAJA5ckm4f4RuQW{color:inherit!important;float:left;margin-top:5px}", ""]);

// exports
exports.locals = {
	"button": "XFcTiFjPua2V0mykElKpy",
	"icon": "_3zf_WOadAJA5ckm4f4RuQW"
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/custom-react-scripts/~/css-loader?modules&-autoprefixer&importLoaders=1!./~/custom-react-scripts/~/postcss-loader!./src/components/icon-button/style.css
 ** module id = 347
 ** module chunks = 0
 **/